/* eslint-disable @typescript-eslint/no-unused-vars */
import { SectionTitle } from 'components';
import React, { useEffect, useRef, useState } from 'react';
import { FormGroup, FormGroupProps, I18n } from 'core';

import { CommunityAPII, CommunityModel } from 'types/models/community';

import { SelectItemI } from 'components/NewInputs/Select/ElecsumSelect';
import { CommunityCustomOnboardingServiceInstance, LoggingService } from 'services';
import CommunitiesServiceIntance from 'services/remote/communities-service';
import customToast from 'components/CustomToast/CustomToast';
import { toast } from 'react-toastify';
import { DayPicker } from 'components/Input';

import { FORMGROUP_TYPES } from 'core/form/FormGroup/FormGroup';

import RangoArrayInput from 'components/Input/RangoArrayInput/RangoArrayInput';
import ComunidadesCustomOnboardingPreguntas from 'pages/ModeTecnic/rol-comunidades/comunidades-custom-onboarding-process-page/components/comunidades-custom-onboarding-preguntas/comunidades-custom-onboarding-preguntas';
import { CommunityCustomOnboarding, CommunityCustomOnboardingAPII, Customizable } from 'types/models';
import './comunidadPicker.scss';

import styles from './comunidades-detalle-details-form.module.scss';

interface ComunidadesDetalleDetailsFormPageProps {
  selectedCommunity: CommunityModel;
  currentLang: SelectItemI;
  afterSubmitAction?: CallableFunction;
  clicked: boolean;
  currentSection: string;
  communityCustomOnboarding: CommunityCustomOnboarding;
  customOnboardingPreguntasRef: any;
  getCustomOnboardingData: any;
  setCommunityCustomOnboarding: React.Dispatch<React.SetStateAction<CommunityCustomOnboarding | undefined>>;
}
export type SaveDataHandle = {
  getData: () => void;
};

const ComunidadesDetalleDetailsFormPage = (props: ComunidadesDetalleDetailsFormPageProps): JSX.Element => {
  const {
    selectedCommunity,
    currentLang,
    afterSubmitAction,
    clicked,
    currentSection,
    communityCustomOnboarding,
    getCustomOnboardingData,
    setCommunityCustomOnboarding,
  } = props;
  const [client, setClient] = useState<CommunityModel>();
  const comunidadPost = JSON.parse(JSON.stringify(selectedCommunity));
  // const [submitDisabled, setSubmitDisabled] = useState<boolean>(false);
  // const [loading, setLoading] = useState(false);

  const customOnboardingPreguntasRef = useRef<SaveDataHandle | null>(null);
  const [errors, setErrors] = useState({});
  const [ModificacionPromocion, setModificacionPromocion] = useState<boolean>(false);
  const [ModificacionTipologia, setModificacionTipologia] = useState<boolean>(false);
  const [ModificacionDescripcion, setModificacionDescripcion] = useState<boolean>(false);
  const [Descripcion, setDescripcion] = useState<string>(selectedCommunity?.descripcion.translations?.es as string);
  const [DescripcionCA, setDescripcionCA] = useState<string>(selectedCommunity?.descripcion.translations?.ca as string);
  const [Promocion, setPromocion] = useState<string>(selectedCommunity?.promocion.translations?.es as string);
  const [PromocionCa, setPromocionCa] = useState<string>(selectedCommunity?.promocion.translations?.ca as string);
  const [Tipologia, setTipologia] = useState<string>(selectedCommunity?.tipologia.translations?.es as string);
  const [TipologiaCa, setTipologiaCa] = useState<string>(selectedCommunity?.tipologia.translations?.ca as string);

  const [impactoClimatico, setimpactoClimatico] = useState<string>(
    selectedCommunity?.impactoClimatico.translations?.es as string,
  );
  const [impactoClimaticoCa, setimpactoClimaticoCa] = useState<string>(
    selectedCommunity?.impactoClimatico.translations?.ca as string,
  );
  const [estadoInicial] = useState<string>(selectedCommunity?.estado);

  function handleChange<T>(path: string, value: T): void {
    let x = {
      es: '',
      ca: '',
    };
    if (path === 'descripcion' || path === 'promocion' || path === 'tipologia' || path === 'impactoClimatico') {
      if (path === 'descripcion') {
        if (currentLang.value === 'Es') {
          x = {
            es: value as unknown as string,
            ca: DescripcionCA,
          };
        } else {
          x = {
            es: Descripcion,
            ca: value as unknown as string,
          };
        }
      }
      if (path === 'promocion') {
        if (currentLang.value === 'Es') {
          x = {
            es: value as unknown as string,
            ca: PromocionCa,
          };
        } else {
          x = {
            es: Promocion,
            ca: value as unknown as string,
          };
        }
      }
      if (path === 'tipologia') {
        if (currentLang.value === 'Es') {
          x = {
            es: value as unknown as string,
            ca: TipologiaCa,
          };
        } else {
          x = {
            es: Tipologia,
            ca: value as unknown as string,
          };
        }
      }

      if (path === 'impactoClimatico') {
        if (currentLang.value === 'Es') {
          x = {
            es: value as unknown as string,
            ca: impactoClimaticoCa,
          };
        } else {
          x = {
            es: impactoClimatico,
            ca: value as unknown as string,
          };
        }
      }

      selectedCommunity.setAttr(path, x);
      setClient(
        new CommunityModel().deserialize({
          ...comunidadPost,
          [path]: x,
        }),
      );
    } else {
      if (path === 'rangoDeGeneracionesConsumoDomestico' || path === 'rangoDeGeneracionesConsumoIndustrial') {
        if (Array.isArray(value)) {
          selectedCommunity.setAttr(path, value);

          setClient(
            new CommunityModel().deserialize({
              ...comunidadPost,
              [path]: value,
            }),
          );
        }

        return;
      }

      selectedCommunity.setAttr(path, value);

      setClient(
        new CommunityModel().deserialize({
          ...comunidadPost,
          [path]: value,
        }),
      );
    }
    if (path === 'promocion') {
      setModificacionPromocion(true);

      if (currentLang.value === 'Es') {
        setPromocion(x.es);
      } else {
        setPromocionCa(x.ca);
      }
    }
    if (path === 'tipologia') {
      setModificacionTipologia(true);
      if (currentLang.value === 'Es') {
        setTipologia(x.es);
      } else {
        setTipologiaCa(x.ca);
      }
    }
    if (path === 'descripcion') {
      setModificacionDescripcion(true);
      if (currentLang.value === 'Es') {
        setDescripcion(x.es);
      } else {
        setDescripcionCA(x.ca);
      }
    }
    if (path === 'impactoClimatico') {
      setModificacionDescripcion(true);
      if (currentLang.value === 'Es') {
        setimpactoClimatico(x.es);
      } else {
        setimpactoClimaticoCa(x.ca);
      }
    }

    if (path === 'plantillaContratoAdgesionEs' || path === 'plantillaContratoAdgesionCa') {
      if (typeof value === 'string') {
        value.toString().replace('#', '');
      }
    }
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async function handleCheckBox<T>(path: string, value: string, id: string, checked: boolean): Promise<unknown> {
    let NewValue: string;
    if (checked) {
      NewValue = 'completa';
    } else {
      NewValue = estadoInicial;
    }
    selectedCommunity.setAttr(path, NewValue);
    await setClient(
      new CommunityModel().deserialize({
        ...comunidadPost,
        [path]: NewValue,
      }),
    );
    return true;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async function handleCheckBoxCheck<T>(path: string, value: string, id: string, checked: boolean): Promise<unknown> {
    let NewValue: string;
    if (checked) {
      NewValue = 'si';
    } else {
      NewValue = 'no';
    }

    selectedCommunity.setAttr(path, NewValue);

    await setClient(
      new CommunityModel().deserialize({
        ...comunidadPost,
        [path]: NewValue,
      }),
    );

    return true;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  function handleCheckBoxOnboarding(path: string, checked: boolean): void {
    setCommunityCustomOnboarding((prev) => {
      if (!prev?.personalizacionOnboarding?.parametersOnboarding) return prev;

      const params = prev.personalizacionOnboarding.parametersOnboarding;

      const next = {
        ...prev,
        personalizacionOnboarding: {
          ...prev.personalizacionOnboarding,
          parametersOnboarding: {
            ...params,
            [path]: checked ? 'si' : 'no', // ✅ solo el que clicaste
          },
        },
      };

      return new CommunityCustomOnboarding().deserialize(next as any);
    });
  }

  const updateCustomOnboarding = async (communityCustomOnboardingUpdate: CommunityCustomOnboarding): Promise<void> => {
    try {
      const anyObj = communityCustomOnboardingUpdate.personalizacionOnboarding.preguntasOpcionalesEncuesta;
      const getParametersOnboarding = communityCustomOnboardingUpdate.personalizacionOnboarding.parametersOnboarding;
      if (anyObj) {
        await CommunityCustomOnboardingServiceInstance.updatePreguntasOpcionalesEncuesta(
          selectedCommunity.id.toString(),
          anyObj,
        );
      }
      if (getParametersOnboarding) {
        await CommunityCustomOnboardingServiceInstance.updatParametersOnboarding(
          selectedCommunity.id.toString(),
          getParametersOnboarding,
        );
      }
      // getCustomOnboardingData();
    } catch (error) {
      toast.error(I18n.t('ComunidadesCustomOnboardingProcess.errors.updating'));
    }
  };

  const getInitalDate = (): Date => {
    const currentDate = new Date(selectedCommunity?.fechaFinInscripciones || new Date());
    const yesterday = new Date(currentDate);
    yesterday.setDate(yesterday.getDate());

    return yesterday;
  };
  const [date, setDate] = useState({
    day: getInitalDate().getDate(),
    month: getInitalDate().getMonth() + 1,
    year: getInitalDate().getFullYear(),
  });
  const updateDate = (newDate: Date): void => {
    if (!newDate) {
      return;
    }
    setDate({
      day: newDate.getDate(),
      month: newDate.getMonth() + 1,
      year: newDate.getFullYear(),
    });
  };
  // Effects
  const validateForm = (): boolean => {
    // setSubmitDisabled(false);
    setErrors({});
    return true;
  };
  const submitReportChanges = async (CommunityModelUpdate: CommunityAPII): Promise<boolean> => {
    const object = CommunityModelUpdate;

    if (ModificacionPromocion === false) {
      object.promocion = comunidadPost.promocion.translations.translations;
    }
    if (ModificacionTipologia === false) {
      object.tipologia = comunidadPost.tipologia.translations.translations;
    }
    if (ModificacionDescripcion === false) {
      object.descripcion = comunidadPost.descripcion.translations.translations;
    }
    if (ModificacionDescripcion === false) {
      object.impactoClimatico = comunidadPost.impactoClimatico.translations.translations;
    }
    if (object.generacionInstalable === '') {
      object.generacionInstalable = '0';
    }
    if (object.potenciaInstalable === '') {
      object.potenciaInstalable = '0';
    }
    object.fechaFinInscripciones = `${date.year}-${date.month}-${date.day}`;
    try {
      // eslint-disable-next-line no-console
      await CommunitiesServiceIntance.putCommunities(JSON.parse(JSON.stringify(object)));
      customToast.success(I18n.t('Comunidad successfully updated'));
    } catch (error) {
      toast.error(I18n.t('Error updating report!'));
    }
    return true;
  };
  const submitForm = async (): Promise<boolean> => {
    // setLoading(true);
    // setSubmitDisabled(true);
    customOnboardingPreguntasRef.current?.getData();

    submitReportChanges(comunidadPost);
    // setLoading(false);
    // setSubmitDisabled(false);
    return true;
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault();

    if (validateForm()) {
      LoggingService.log('handleSubmit :: ok', { client });
      submitForm();
    } else {
      LoggingService.log('handleSubmit :: errors', { client, errors });
    }
  };
  useEffect(() => {
    if (clicked === true) {
      if (validateForm()) {
        LoggingService.log('handleSubmit :: ok', { client });
        submitForm();
        if (afterSubmitAction) {
          afterSubmitAction();
        }
      } else {
        LoggingService.log('handleSubmit :: errors', { client, errors });
      }
    }
  }, [clicked]);
  const formFieldsLeft: Array<FormGroupProps> = [
    {
      label: I18n.t('ComunidadesDetallePage.detailData.labels.name'),
      type: 'string',
      id: 'nombre',
      path: 'nombre',
      name: 'nombre',
      placeholder: '',
      value: selectedCommunity?.nombre,
    },
    {
      label: I18n.t('ComunidadesDetallePage.detailData.labels.domicilio'),
      type: 'string',
      id: 'domicilio',
      path: 'domicilio',
      name: 'domicilio',
      placeholder: '',
      value: selectedCommunity.domicilio,
    },
    {
      label: I18n.t('ComunidadesDetallePage.detailData.labels.poblacion'),
      type: 'string',
      id: 'poblacion',
      path: 'poblacion',
      name: 'poblacion',
      placeholder: '',
      value: selectedCommunity.poblacion,
    },
    {
      label: I18n.t('ComunidadesDetallePage.detailData.labels.codigoPostal'),
      type: 'string',
      id: 'codigoPostal',
      path: 'codigoPostal',
      name: 'codigoPostal',
      placeholder: '',
      value: selectedCommunity.codigoPostal,
    },
    {
      label: I18n.t('ComunidadesDetallePage.detailData.labels.provincia'),
      type: 'string',
      id: 'provincia',
      path: 'provincia',
      name: 'provincia',
      placeholder: '',
      value: selectedCommunity.provincia,
    },
  ];
  const formFieldsLeft2: Array<FormGroupProps> = [
    {
      label: I18n.t('ComunidadesDetallePage.detailData.labels.radioAlcance'),
      type: 'string',
      id: 'radioAlcance',
      path: 'radioAlcance',
      name: 'radioAlcance',
      min: 0,
      placeholder: '',
      value: selectedCommunity.radioAlcance,
    },
    {
      label: I18n.t('ComunidadesDetallePage.detailData.labels.prioridad'),
      type: 'number',
      id: 'prioridad',
      path: 'prioridad',
      name: 'prioridad',
      min: 0,
      placeholder: '',
      value: selectedCommunity.prioridad,
    },
    {
      label: I18n.t('ComunidadesDetallePage.detailData.labels.descripcion'),
      type: 'textarea',
      id: 'descripcion',
      path: 'descripcion',
      name: 'descripcion',
      placeholder: '',
      // eslint-disable-next-line no-nested-ternary
      value: currentLang.value === 'Ca' ? (DescripcionCA === undefined ? '' : DescripcionCA) : Descripcion,
    },
  ];

  const formFieldsRight: Array<FormGroupProps> = [
    {
      label: I18n.t('ComunidadesDetallePage.detailData.labels.tipologia'),
      type: 'string',
      id: 'tipologia',
      path: 'tipologia',
      name: 'tipologia',
      placeholder: '',
      value: currentLang.value === 'Ca' ? TipologiaCa : Tipologia,
    },
    {
      label: I18n.t('ComunidadesDetallePage.detailData.labels.promocion'),
      type: 'string',
      id: 'promocion',
      path: 'promocion',
      name: 'promocion',
      placeholder: '',
      // eslint-disable-next-line no-nested-ternary
      value: currentLang.value === 'Ca' ? (PromocionCa === undefined ? '' : PromocionCa) : Promocion,
    },
    {
      label: I18n.t('ComunidadesDetallePage.detailData.labels.generacion'),
      type: 'string',
      id: 'generacionInstalable',
      path: 'generacionInstalable',
      name: 'generacionInstalable',
      value: selectedCommunity?.generacionInstalable === '0' ? '' : selectedCommunity?.generacionInstalable,
      placeholder: '',
      readOnly: false,
    },
    {
      label: I18n.t('ComunidadesDetallePage.detailData.labels.potenciainstalable'),
      type: 'string',
      id: 'potenciaInstalable',
      path: 'potenciaInstalable',
      name: 'potenciaInstalable',
      value: selectedCommunity?.potenciaInstalable === '0' ? '' : selectedCommunity?.potenciaInstalable,
      placeholder: '',
      readOnly: false,
    },
    {
      label: I18n.t('ComunidadesDetallePage.detailData.labels.co2'),
      type: 'string',
      id: 'impactoClimatico',
      path: 'impactoClimatico',
      name: 'impactoClimatico',
      placeholder: '',
      readOnly: false,
      value:
        // eslint-disable-next-line no-nested-ternary
        currentLang.value === 'Ca' ? (impactoClimaticoCa === undefined ? '' : impactoClimaticoCa) : impactoClimatico,
    },
    {
      label: I18n.t('ComunidadesDetallePage.detailData.labels.titularPoliticaPrivacidad'),
      type: 'string',
      id: 'titularPoliticaPrivacidad',
      path: 'titularPoliticaPrivacidad',
      name: 'titularPoliticaPrivacidad',
      placeholder: '',
      value: selectedCommunity.titularPoliticaPrivacidad,
    },
  ];
  const formcheckbosleft: Array<FormGroupProps> = [
    {
      label: I18n.t('ComunidadesListPage.estado.titulo'),

      type: FORMGROUP_TYPES.select,
      id: 'estado',
      path: 'estado',
      name: 'estado',
      placeholder: 'wwww',
      value: selectedCommunity?.estado,

      options: [
        { label: 'abierta', value: 'abierta' },
        { label: 'completa', value: 'completa' },
        { label: 'oculta', value: 'oculta' },
        { label: 'cerrada', value: 'cerrada' },
      ],
    },
  ];
  const formSelectTipoComunidad: Array<FormGroupProps> = [
    {
      label: I18n.t('ComunidadesListPage.tipoDeComunidad.titulo'),

      type: FORMGROUP_TYPES.select,
      id: 'tipoDeComunidad',
      path: 'tipoDeComunidad',
      name: 'tipoDeComunidad',
      placeholder: 'wwww',
      value: selectedCommunity?.tipoDeComunidad,

      options: [
        { label: 'ComunidadesListPage.tipoDeComunidad.estandard', value: 'estandart' },
        { label: 'ComunidadesListPage.tipoDeComunidad.otc', value: 'otc' },
      ],
    },
  ];

  const formGroupsEnviarAutorizacionAPromotor: Array<FormGroupProps> = [
    {
      label: I18n.t('ComunidadesListPage.tipoDeComunidad.checkSignaturitPromotor'),
      type: 'checkbox',
      id: 'enviarAutorizacionAPromotor',
      path: 'enviarAutorizacionAPromotor',
      name: 'enviarAutorizacionAPromotor',
      checked: selectedCommunity.enviarAutorizacionAPromotor === 'si',
      value: selectedCommunity.enviarAutorizacionAPromotor === 'si',
    },
  ];

  const formGroupModalData: Array<FormGroupProps> = [
    {
      label: I18n.t('ComunidadesDetallePage.detailData.labels.iAonboarding'),

      type: 'checkbox',
      id: 'permisoIaOnboarding',
      path: 'permisoIaOnboarding',
      name: 'permisoIaOnboarding',
      value: selectedCommunity.permisoIaOnboarding === 'si',
      checked: selectedCommunity.permisoIaOnboarding === 'si',
    },
    {
      label: I18n.t('ComunidadesDetallePage.detailData.labels.datadis'),
      type: 'checkbox',
      id: 'flujoOriginalDatadis',
      path: 'flujoOriginalDatadis',
      name: 'flujoOriginalDatadis',
      value: selectedCommunity.flujoOriginalDatadis === 'si',
      checked: selectedCommunity.flujoOriginalDatadis === 'si',
    },
    {
      label: I18n.t('ComunidadesDetallePage.detailData.labels.encuesta'),
      type: 'checkbox',
      id: 'encuestaObligatoria',
      path: 'encuestaObligatoria',
      name: 'encuestaObligatoria',
      value: selectedCommunity.encuestaObligatoria === 'si',
      checked: selectedCommunity.encuestaObligatoria === 'si',
    },
    {
      label: I18n.t('ComunidadesDetallePage.detailData.labels.forzarValidacionInscrito'),
      type: 'checkbox',
      id: 'forzarValidacionInscrito',
      path: 'forzarValidacionInscrito',
      name: 'forzarValidacionInscrito',
      value: selectedCommunity.forzarValidacionInscrito === 'si',
      checked: selectedCommunity.forzarValidacionInscrito === 'si',
    },
  ];

  const formFieldsPersonalizacionCheckBoxes: Array<FormGroupProps> = [
    {
      label: I18n.t('ComunidadesCustomOnboardingProcess.form.labels.forzarpaso2'),
      type: 'checkbox',
      id: 'forzarPasoDos',
      path: 'forzarPasoDos', // Update the path
      name: 'forzarPasoDos',
      checked: communityCustomOnboarding?.personalizacionOnboarding.parametersOnboarding.forzarPasoDos === 'si',
      value: communityCustomOnboarding?.personalizacionOnboarding.parametersOnboarding.forzarPasoDos,
    },
    {
      label: I18n.t('ComunidadesCustomOnboardingProcess.form.labels.comunicacionesComerciales'),
      type: 'checkbox',
      id: 'comunicacionesComerciales',
      path: 'comunicacionesComerciales', // Update the path
      name: 'comunicacionesComerciales',
      checked:
        communityCustomOnboarding?.personalizacionOnboarding.parametersOnboarding.comunicacionesComerciales === 'si',
      value: communityCustomOnboarding?.personalizacionOnboarding.parametersOnboarding.comunicacionesComerciales,
    },
    {
      label: I18n.t('ComunidadesListPage.tipoClientePorDefecto.titulo'),

      type: FORMGROUP_TYPES.select,
      id: 'tipoClientePorDefecto',
      path: 'tipoClientePorDefecto',
      name: 'tipoClientePorDefecto',
      placeholder: 'wwww',
      value: selectedCommunity?.tipoClientePorDefecto,
      className: styles.corto,

      options: [
        { label: 'ComunidadesListPage.tipoClientePorDefecto.particular', value: 'particular' },
        { label: 'ComunidadesListPage.tipoClientePorDefecto.empresa', value: 'empresa' },
      ],
    },
  ];

  const formGroupComunityNuevosDatos: Array<FormGroupProps> = [
    {
      label: I18n.t('ComunidadesDetallePage.detailData.labels.plantillaContratoAdhesionEs'),

      type: 'string',
      id: 'plantillaContratoAdgesionEs',
      path: 'plantillaContratoAdgesionEs',
      name: 'plantillaContratoAdgesionEs',
      value: selectedCommunity?.plantillaContratoAdgesionEs || 0,
    },

    {
      label: I18n.t('ComunidadesDetallePage.detailData.labels.plantillaContratoAdhesionCa'),
      type: 'string',
      id: 'plantillaContratoAdgesionCa',
      path: 'plantillaContratoAdgesionCa',
      name: 'plantillaContratoAdgesionCa',
      value: selectedCommunity?.plantillaContratoAdgesionCa,
    },
    {
      label: I18n.t('ComunidadesDetallePage.detailData.labels.duracionDelContrato'),

      type: 'number',
      id: 'duracionDelContrato',
      path: 'duracionDelContrato',
      name: 'duracionDelContrato',
      value: selectedCommunity?.duracionDelContrato || 0,
    },

    {
      label: I18n.t('ComunidadesDetallePage.detailData.labels.precioAccesoDerechoExclusivo'),
      type: 'number',
      id: 'precioAccesoDerechoExclusivo',
      path: 'precioAccesoDerechoExclusivo',
      name: 'precioAccesoDerechoExclusivo',
      value: selectedCommunity?.precioAccesoDerechoExclusivo,
    },

    {
      label: I18n.t('ComunidadesDetallePage.detailData.labels.precioAccesoAhorraSiempre'),
      type: 'number',
      id: 'precioAccesoAhorraSiempre',
      path: 'precioAccesoAhorraSiempre',
      name: 'precioAccesoAhorraSiempre',
      value: selectedCommunity?.precioAccesoAhorraSiempre,
    },
    {
      label: I18n.t('ComunidadesDetallePage.detailData.labels.precioAccesoVendaEnergia'),
      type: 'number',
      id: 'precioAccesoVendaEnergia',
      path: 'precioAccesoVendaEnergia',
      name: 'precioAccesoVendaEnergia',
      value: selectedCommunity?.precioAccesoVendaEnergia,
    },
    {
      label: I18n.t('ComunidadesDetallePage.detailData.labels.limiteDeAutoconsumo'),
      type: 'number',
      id: 'limiteDeAutoconsumo',
      path: 'limiteDeAutoconsumo',
      name: 'limiteDeAutoconsumo',
      value: selectedCommunity?.limiteDeAutoconsumo || 0,
      min: 0,
      max: 100,
    },
    {
      label: I18n.t('ComunidadesDetallePage.detailData.labels.limitacionNumeroInscripciones'),
      type: FORMGROUP_TYPES.number,
      id: 'limitacionNumeroInscripciones',
      path: 'limitacionNumeroInscripciones',
      name: 'limitacionNumeroInscripciones',
      placeholder: '',
      value: selectedCommunity.limitacionNumeroInscripciones,
    },
    {
      label: I18n.t('ComunidadesDetallePage.detailData.labels.precioCompensacion'),
      type: FORMGROUP_TYPES.number,
      id: 'precioCompensacion',
      path: 'precioCompensacion',
      name: 'precioCompensacion',
      placeholder: '',
      value: selectedCommunity.precioCompensacion,
      step: 0.01,
    },
  ];

  const formGroupPotenciaDatosExtras: Array<FormGroupProps> = [
    {
      label: I18n.t('ComunidadesDetallePage.detailData.labels.excedentes'),
      type: FORMGROUP_TYPES.select,
      id: 'excedentes',
      path: 'excedentes',
      name: 'excedentes',
      value: selectedCommunity?.excedentes,
      options: [
        { label: 'ComunidadesDetallePage.detailData.labels.noExcedentes', value: 0 },
        { label: 'ComunidadesDetallePage.detailData.labels.conExcedentes', value: 1 },
        { label: 'ComunidadesDetallePage.detailData.labels.sinCompensacion', value: 2 },
      ],
      placeholder: 'wwww',
    },
    {
      label: I18n.t('ComunidadesDetallePage.detailData.labels.modosDeAcceso'),
      type: FORMGROUP_TYPES.multiRadio,
      id: 'modosDeAccesoOfertas',
      path: 'modosDeAccesoOfertas',
      name: 'modosDeAccesoOfertas',
      value: selectedCommunity?.modosDeAccesoOfertas,
      options: [
        { label: I18n.t('ComunidadesDetallePage.detailData.labels.ahorraSiempre'), value: 0 },
        { label: I18n.t('ComunidadesDetallePage.detailData.labels.derechoExclusivo'), value: 1 },
        { label: I18n.t('ComunidadesDetallePage.detailData.labels.vendaEnergia'), value: 2 },
      ],
      placeholder: 'wwww',
    },
    {
      label: I18n.t('ComunidadesDetallePage.detailData.labels.kwNominales'),
      type: 'number',
      id: 'kwNominales',
      path: 'kwNominales',
      name: 'kwNominales',
      readOnly: false,
      value: selectedCommunity?.kwNominales || 0,
    },
  ];
  return (
    <div className={styles.root}>
      <form className={styles.form} onSubmit={handleSubmit}>
        {currentSection === 'DETALLES' && (
          <>
            <div className={styles.containerForms} style={{ marginTop: '4rem' }}>
              <div className={styles.containerForm}>
                {formFieldsLeft.map((formGroup: FormGroupProps) => (
                  <FormGroup
                    key={formGroup.id}
                    label={formGroup.label}
                    type={formGroup.type}
                    id={formGroup.id}
                    path={formGroup.path}
                    name={formGroup.name}
                    placeholder={formGroup.placeholder}
                    value={formGroup.value}
                    required={formGroup.required}
                    onChange={handleChange}
                    readOnly={formGroup.readOnly}
                    className={formGroup.className}
                    maxLenght={200}
                  />
                ))}
                <div>
                  <label className={styles.labelDatepicker} htmlFor="fechaFinInscripciones" id="fechaFinInscripciones">
                    {I18n.t('ComunidadesDetallePage.detailData.labels.date')}
                  </label>
                  <div className={styles.inputDatepicker}>
                    <DayPicker date={new Date(`${date.month}/${date.day}/${date.year}`)} onChangeDate={updateDate} />
                  </div>
                </div>
                {formFieldsLeft2.map((formGroup: FormGroupProps) => (
                  <FormGroup
                    key={formGroup.id}
                    label={formGroup.label}
                    type={formGroup.type}
                    id={formGroup.id}
                    path={formGroup.path}
                    name={formGroup.name}
                    placeholder={formGroup.placeholder}
                    value={formGroup.value}
                    required={formGroup.required}
                    onChange={handleChange}
                    readOnly={formGroup.readOnly}
                    className={formGroup.className}
                  />
                ))}
              </div>
              <div className={styles.margenesLefst}>
                {formFieldsRight.map((formGroup: FormGroupProps) => (
                  <FormGroup
                    key={formGroup.id}
                    label={formGroup.label}
                    type={formGroup.type}
                    id={formGroup.id}
                    path={formGroup.path}
                    name={formGroup.name}
                    placeholder={formGroup.placeholder}
                    value={formGroup.value}
                    required={formGroup.required}
                    readOnly={formGroup.readOnly}
                    className={formGroup.className}
                    onChange={handleChange}
                    maxLenght={200}
                  />
                ))}

                {/* <p>{t(`ComunidadesListPage.Inscrits`)}</p>
              <p>{t(`ComunidadesListPage.Places`)}</p> */}

                {formcheckbosleft.map((formGroup: FormGroupProps) => (
                  <FormGroup
                    key={formGroup.id}
                    label={formGroup.label}
                    type={formGroup.type}
                    id={formGroup.id}
                    path={formGroup.path}
                    name={formGroup.name}
                    placeholder={formGroup.placeholder}
                    value={formGroup.value}
                    required={formGroup.required}
                    onChange={handleChange}
                    options={formGroup.options}
                    className={styles.removeMargin}
                  />
                ))}

                {formSelectTipoComunidad.map((formGroup: FormGroupProps) => (
                  <FormGroup
                    key={formGroup.id}
                    label={formGroup.label}
                    type={formGroup.type}
                    id={formGroup.id}
                    path={formGroup.path}
                    name={formGroup.name}
                    placeholder={formGroup.placeholder}
                    value={formGroup.value}
                    required={formGroup.required}
                    onChange={handleChange}
                    options={formGroup.options}
                  />
                ))}

                {formGroupsEnviarAutorizacionAPromotor.map((formGroup: FormGroupProps) => (
                  <FormGroup
                    key={formGroup.id}
                    label={formGroup.label}
                    type={formGroup.type}
                    id={formGroup.id}
                    path={formGroup.path}
                    name={formGroup.name}
                    value={formGroup.value}
                    checked={formGroup.checked}
                    onChange={handleCheckBoxCheck}
                  />
                ))}
              </div>
            </div>
          </>
        )}

        {currentSection === 'ONBOARDING' && (
          <>
            <div className={styles.configSection}>
              <div className={styles.configBlock}>
                {formGroupModalData.map((formGroup: FormGroupProps) => (
                  <FormGroup
                    key={formGroup.id}
                    label={formGroup.label}
                    type={formGroup.type}
                    id={formGroup.id}
                    path={formGroup.path}
                    name={formGroup.name}
                    value={formGroup.value}
                    checked={formGroup.checked}
                    onChange={handleCheckBoxCheck}
                  />
                ))}
                {formFieldsPersonalizacionCheckBoxes.map((fg) => {
                  const isOn =
                    communityCustomOnboarding?.personalizacionOnboarding.parametersOnboarding[
                      fg.path as keyof typeof communityCustomOnboarding.personalizacionOnboarding.parametersOnboarding
                    ] === 'si';

                  return fg.type !== FORMGROUP_TYPES.select ? (
                    <FormGroup
                      key={fg.id}
                      label={fg.label}
                      type={fg.type}
                      id={fg.id}
                      path={fg.path}
                      name={fg.name}
                      value={isOn}
                      checked={isOn}
                      onChange={(path: any, _value: any, _id: any, checked: any) =>
                        handleCheckBoxOnboarding(path as string, Boolean(checked ?? _value))
                      }
                    />
                  ) : (
                    <FormGroup
                      key={fg.id}
                      label={fg.label}
                      type={fg.type}
                      id={fg.id}
                      path={fg.path}
                      name={fg.name}
                      placeholder={fg.placeholder}
                      value={fg.value}
                      required={fg.required}
                      onChange={handleChange}
                      readOnly={fg.readOnly}
                      className={fg.className}
                      maxLenght={200}
                      min={0}
                      max={100}
                      step={fg.step || 1}
                      options={fg.options}
                    />
                  );
                })}
              </div>
              <SectionTitle text={I18n.t('ComunidadesDetallePage.detailData.parametrosEconomicos')} />

              <div className={styles.configBlock}>
                <div className={styles.twoColumnGrid}>
                  {formGroupComunityNuevosDatos.map((formGroup: FormGroupProps) => (
                    <FormGroup
                      key={formGroup.id}
                      label={formGroup.label}
                      type={formGroup.type}
                      id={formGroup.id}
                      path={formGroup.path}
                      name={formGroup.name}
                      placeholder={formGroup.placeholder}
                      value={formGroup.value}
                      required={formGroup.required}
                      onChange={handleChange}
                      readOnly={formGroup.readOnly}
                      className={formGroup.className}
                      maxLenght={200}
                      min={0}
                      max={100}
                      step={formGroup.step || 1}
                      options={formGroup.options}
                    />
                  ))}
                </div>
              </div>
              <SectionTitle text={I18n.t('ComunidadesDetallePage.detailData.potencias')} />

              <div className={styles.configBlock}>
                <div className={styles.twoColumnGrid}>
                  <RangoArrayInput
                    id="rangoDeGeneracionesConsumoDomestico"
                    name="rangoDeGeneracionesConsumoDomestico"
                    path="rangoDeGeneracionesConsumoDomestico"
                    label={I18n.t('ComunidadesDetallePage.detailData.labels.rangoDeGeneracionesConsumoDomestico')}
                    value={selectedCommunity?.rangoDeGeneracionesConsumoDomestico || []}
                    onChange={handleChange}
                  />
                  <RangoArrayInput
                    id="rangoDeGeneracionesConsumoIndustrial"
                    name="rangoDeGeneracionesConsumoIndustrial"
                    path="rangoDeGeneracionesConsumoIndustrial"
                    label={I18n.t('ComunidadesDetallePage.detailData.labels.rangoDeGeneracionesConsumoIndustrial')}
                    value={selectedCommunity?.rangoDeGeneracionesConsumoIndustrial || []}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <SectionTitle text={I18n.t('ComunidadesDetallePage.detailData.excedentesTitulo')} />

              <div className={styles.configBlock}>
                <div className={styles.twoColumnGrid}>
                  {formGroupPotenciaDatosExtras.map((formGroup: FormGroupProps) => (
                    <FormGroup
                      key={formGroup.id}
                      label={formGroup.label}
                      type={formGroup.type}
                      id={formGroup.id}
                      path={formGroup.path}
                      name={formGroup.name}
                      placeholder={formGroup.placeholder}
                      value={formGroup.value}
                      required={formGroup.required}
                      onChange={handleChange}
                      readOnly={formGroup.readOnly}
                      className={formGroup.className}
                      maxLenght={200}
                      options={formGroup.options}
                    />
                  ))}
                </div>
              </div>

              <div className={styles.configBlock}>
                <ComunidadesCustomOnboardingPreguntas
                  ref={customOnboardingPreguntasRef}
                  communityCustomOnboarding={communityCustomOnboarding}
                  saveDetails={(customOnboarding) =>
                    updateCustomOnboarding(customOnboarding as CommunityCustomOnboarding)
                  }
                />
              </div>
            </div>
          </>
        )}
      </form>
    </div>
  );
};

export default ComunidadesDetalleDetailsFormPage;
